module.exports = __webpack_public_path__ + "media/Speaker_low.36c9d3bc.mp4";